import { cn } from "@-/com.npmjs.cn";
import { useMemo } from "react";
/* eslint-disable react-native/no-inline-styles -- key width and height are layout-driven */
import {
  Pressable,
  type PressableProps,
  type StyleProp,
  type ViewStyle,
} from "@-/com.npmjs.react-native";
import { onscreenKeyboardKeyBorderClassName } from "#onscreen-keyboard-key-border-class-name";

const onscreenKeyboardKeySurfaceClassName = cn(
  "relative overflow-hidden rounded-xs bg-muted active:bg-accent dark:bg-muted/80",
  onscreenKeyboardKeyBorderClassName,
);

export type OnscreenKeyboardKeyProps = Omit<PressableProps, "style"> & {
  /** Visual fade for inactive-looking keys (e.g. tone keys that do not apply yet). */
  dimmed?: boolean;
  height: number;
  /** Matches the selected / in-progress look used on letter keys. */
  highlighted?: boolean;
  style?: StyleProp<ViewStyle>;
  width: number;
};

export function OnscreenKeyboardKey({
  className,
  dimmed,
  height,
  highlighted,
  style: styleProp,
  width,
  ...rest
}: OnscreenKeyboardKeyProps) {
  const style = useMemo(
    (): StyleProp<ViewStyle> => [{ borderCurve: "continuous", height, width }, styleProp],
    [height, width, styleProp],
  );
  return (
    <Pressable
      className={cn(
        onscreenKeyboardKeySurfaceClassName,
        highlighted && "border-primary bg-primary/15 dark:bg-primary/20",
        dimmed && "opacity-40",
        className,
      )}
      style={style}
      {...rest}
    />
  );
}
/* eslint-enable react-native/no-inline-styles -- end of layout-driven inline styles in this module */
